module.exports = __webpack_public_path__ + "img/delete.8d57f746.svg";